import { render, staticRenderFns } from "./AccountsSettings.vue?vue&type=template&id=655dc289&"
import script from "./AccountsSettings.vue?vue&type=script&lang=js&"
export * from "./AccountsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports